// Set up your root reducer here...
import { combineReducers } from 'redux';
import customParams from './customParamsReducer';
import hostingElement from './embeddedFormReducer';
import app from './appReducer';

const rootReducer = combineReducers({
  app,
  customParams,
  hostingElement
});

export default rootReducer;
